import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createVNode as _createVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fee4985"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "field-container" }
const _hoisted_2 = { class: "label" }
const _hoisted_3 = { class: "sync-op-title text-secondary" }
const _hoisted_4 = { for: "works" }
const _hoisted_5 = ["value"]
const _hoisted_6 = {
  key: 2,
  class: "row items-center"
}
const _hoisted_7 = { class: "text-warning" }
const _hoisted_8 = { class: "field-container" }
const _hoisted_9 = { for: "about" }
const _hoisted_10 = { class: "dialog-actions" }
const _hoisted_11 = ["disabled"]

import { computed, onMounted, ref } from 'vue'
import { useGettext } from 'vue3-gettext'
import { useSyncOpsStore } from '@/store/syncOpportunities'
import { useWorksStore } from '@/store/works'
import { workFilters } from '@/constants'
import { getErrorTitle, getErrorMessage } from '@/helpers/errors'
import DialogUI from '@/components/CommonUI/DialogUI.vue'
import IconUI from '@/components/CommonUI/IconUI.vue'
import LoaderUI from '@/components/CommonUI/LoaderUI.vue'
import { AxiosError } from 'axios'
import NotificationUI from '../CommonUI/NotificationUI.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ApplyDialog',
  props: {
    syncOp: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;



const { $gettext } = useGettext()
const workStore = useWorksStore()
const syncOpsStore = useSyncOpsStore()

const aboutTheOwner = ref('')
const dialog = ref<IDialogUI>()
const errorMessage = ref('')
const errorTitle = ref('')
const isLoading = ref(true)
const isApplying = ref(false)
const selectedWorkId = ref<number>(0)

const isFormValid = computed(
  () => Boolean(selectedWorkId.value && aboutTheOwner.value.length),
)

onMounted(async () => {
  try {
    isLoading.value = true

    const approvedStatuses = workFilters.Approved
    await workStore.getUserWorksByStatuses(approvedStatuses, false)

    isLoading.value = false
  } catch (error) {
    errorTitle.value = getErrorTitle(error)
    errorMessage.value = getErrorMessage(error)
  }
})

function reset() {
  errorTitle.value = ''
  errorMessage.value = ''
  selectedWorkId.value = 0
  aboutTheOwner.value = ''
}

function show() {
  dialog.value?.show()
}

function hide() {
  dialog.value?.hide()
  reset()
}

async function apply() {
  if (isApplying.value) return

  const syncOpId = props.syncOp.id
  const workId = selectedWorkId.value
  const details = aboutTheOwner.value

  errorTitle.value = ''
  errorMessage.value = ''

  if (!isFormValid.value) {
    if (!workId) {
      errorTitle.value = $gettext('You must select one of your works to apply.')
      return
    }
    if (!details.length) {
      errorTitle.value = $gettext('Please enter some details about yourself.')
      return
    }
  }

  try {
    isApplying.value = true
    await syncOpsStore.applyForSyncOp(syncOpId, workId, details)
    const syncOp = syncOpsStore.syncOps.find(syncOp => syncOp.id === syncOpId)
    if (syncOp) syncOp.wasAppliedFor = true
    hide()
  } catch (error) {
    if (error instanceof AxiosError && error.response?.status === 400) {
      errorTitle.value = $gettext('Try again later')
      errorMessage.value = $gettext("We're still processing this release for sync. Please try again later.")
    } else {
      errorTitle.value = getErrorTitle(error)
      errorMessage.value = getErrorMessage(error)
    }
  } finally {
    isApplying.value = false
  }
}

__expose({
  show,
  hide,
})

return (_ctx: any,_cache: any) => {
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createBlock(DialogUI, {
    ref_key: "dialog",
    ref: dialog,
    size: "medium",
    title: _unref($gettext)('Sync Application'),
    dismissible: "",
    onDialogClosed: reset
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        (errorMessage.value || errorTitle.value)
          ? (_openBlock(), _createBlock(NotificationUI, {
              key: 0,
              title: errorTitle.value,
              message: errorMessage.value
            }, null, 8, ["title", "message"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_1, [
          _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_2, [
            _createTextVNode(" Sync you are applying for: ")
          ])), [
            [_directive_translate]
          ]),
          _createElementVNode("p", _hoisted_3, _toDisplayString(props.syncOp.title), 1)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass({ 'field-container': Boolean(_unref(workStore).works.length) })
        }, [
          _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_4, [
            _createTextVNode("Select a work:")
          ])), [
            [_directive_translate]
          ]),
          (isLoading.value)
            ? (_openBlock(), _createBlock(LoaderUI, { key: 0 }))
            : (_unref(workStore).works.length)
              ? _withDirectives((_openBlock(), _createElementBlock("select", {
                  key: 1,
                  id: "works",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedWorkId).value = $event)),
                  name: "works"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(workStore).works, (work) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: work.id,
                      value: work.id
                    }, _toDisplayString(work.titleWithMix), 9, _hoisted_5))
                  }), 128))
                ], 512)), [
                  [_vModelSelect, selectedWorkId.value]
                ])
              : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(IconUI, {
                    name: "danger",
                    fill: "warning"
                  }),
                  _createTextVNode("   "),
                  _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_7, [
                    _createTextVNode(" No works to select ")
                  ])), [
                    [_directive_translate]
                  ])
                ]))
        ], 2),
        _createElementVNode("div", _hoisted_8, [
          _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_9, [
            _createTextVNode("Tell us more about you:")
          ])), [
            [_directive_translate]
          ]),
          _withDirectives(_createElementVNode("textarea", {
            id: "about",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((aboutTheOwner).value = $event)),
            name: "about",
            rows: "4",
            "data-testid": "about-textbox"
          }, null, 512), [
            [_vModelText, aboutTheOwner.value]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("button", {
          type: "button",
          disabled: isApplying.value,
          onClick: apply
        }, _toDisplayString(_unref($gettext)('Apply')), 9, _hoisted_11)
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})